import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from '../dashboard.module.scss';
import Loader from '../../../_common/Loader/Loader';
import { getDashboardStatsRequest } from '../../../../store/actions/dashboard';

const DashboardKPIStats = ({ requestData }) => {
  const dispatch = useDispatch();
  const { dashboardStats } = useSelector((store) => store.dashboard);

  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        await dispatch(getDashboardStatsRequest(requestData));

        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  return (
    <div className={classes.stats_wrapper}>
      {loading
        ? <Loader />

        : (
          <>
            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.activePatients) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.activePatients)}</h3>

              <p>Active Patients</p>
            </div>

            <div className={classes.stats}>
              <h3>{`${isNaN(dashboardStats.pdcAbove88Rate) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.pdcAbove88Rate)}%`}</h3>

              <p>PDC ≥ 88%</p>
            </div>

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.avgTimeToTherapy) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.avgTimeToTherapy)}</h3>

              <p>AVG Time To Therapy</p>
            </div>

            <div className={classes.stats}>
              <h3>{`${isNaN(dashboardStats.paApprovalRate) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.paApprovalRate)}%`}</h3>

              <p>PA approval rate</p>
            </div>

            <div className={classes.stats}>
              <h3>{`${isNaN(dashboardStats.refillRate) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.refillRate)}%`}</h3>

              <p>Refill on time</p>
            </div>

            <div className={classes.stats}>
              <h3>{`$${isNaN(dashboardStats.revenuePerPatient) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.revenuePerPatient)}`}</h3>

              <p>Revenue / patient</p>
            </div>

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.copayAssistRate) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.copayAssistRate)}</h3>

              <p>Copay assist rate</p>
            </div>

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.avgDaysSupply) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.avgDaysSupply)}</h3>

              <p>Avg days supply</p>
            </div>
          </>
        )}
    </div>
  );
};

export default DashboardKPIStats;
